import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';

//import components
import SimpleSearchResultsListItem from './SimpleSearchResultsListItem.js';
import Pagination from '../pagination/Pagination.js';
import ItemsPerPage from '../items-per-page/ItemsPerPage.js';
import PaginationList from '../pagination/PaginationList.js';
import SortItems from '../sort-items/SortItems.js';
import NoResults from './NoResults.js';

const SimpleSearchResultsList =
    ({ results, activeTab, clang, isFieldsOpen, isMobile, currentPageState,
        ipp, setSortOption, setNextPage, setPreviousPage, setIpp, setCurrentPage, resetPageOnBlur, setPageByNum,
        perPage, allowedSorting, sorting, totalPages, page }) => {
          
    const resultItems = results.map((result, index) => {
        return <SimpleSearchResultsListItem {...result} isMobile={isMobile} isFieldsOpen={isFieldsOpen} key={index}/>;
    });

    return (
        <div className="results__list-container">
            <div className="results__top-navigation">
                <div className="results__top-navigation--left">
                    <ItemsPerPage ipp={ipp} setIpp={setIpp} activeIpp={perPage}/>
                    <SortItems
                        sortOptions={allowedSorting}
                        activeSorting={sorting}
                        setSortOption={setSortOption}/>
                </div>
                <div className="results__top-navigation--right">
                    <Pagination
                        totalPages={totalPages}
                        currentPage={page}
                        currentPageState={currentPageState}
                        setCurrentPage={setCurrentPage}
                        resetPageOnBlur={resetPageOnBlur}
                        setPageByNum={setPageByNum}
                        setNextPage={setNextPage}
                        setPreviousPage={setPreviousPage}/>
                </div>
            </div>
            {results.length > 0 &&
                <ul className="results__list">
                    {resultItems}
                </ul>}
            {results.length === 0 &&
                <NoResults />}
            <div className="results__bottom-navigation">
                <div className="results__bottom-navigation--right">
                    <PaginationList
                        totalPages={totalPages}
                        currentPage={page}
                        setPageByNum={setPageByNum}
                        setNextPage={setNextPage}
                        setPreviousPage={setPreviousPage}/>
                </div>
            </div>
        </div>
    );
};

SimpleSearchResultsList.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SimpleSearchResultsList);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/SimpleSearchResultsList.js